// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Organisation_wrapper__lNtDX","orgImage":"Organisation_orgImage__1Tq9q"};